'use client'

import { Flex, Spinner } from '@chakra-ui/react'
import { useGetDonorDetailQuery } from '@entities/donor/api/get-donor.api'
import { DonorDeferralHistoryCard } from '@/widgets/deferrals'

interface Props {
  visitId: string
  /** Lifting a deferral is the registrar/therapist side's action. */
  canOverrideDeferral?: boolean
}

/** «Отводы» — temporary and permanent deferrals of the donor, newest first. */
export function DeferredTab({ visitId, canOverrideDeferral = false }: Props) {
  const { data: donorDetail, isPending } = useGetDonorDetailQuery(visitId)

  if (isPending) {
    return (
      <Flex justify="center" align="center" minH="200px">
        <Spinner size="lg" color="primary.fg" />
      </Flex>
    )
  }
  if (!donorDetail) return null

  return (
    <DonorDeferralHistoryCard
      donorId={donorDetail.donor_id}
      donorName={donorDetail.full_name}
      canOverride={canOverrideDeferral}
    />
  )
}
